var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.transformData),function(item){return _c('div',{key:item.id,class:['trapezium', item.id === _vm.activityId ? 'activity' :''],on:{"click":function($event){return _vm.handleToggle(item.id)}}},[_c('div',{staticClass:"item"}),_c('p',{staticClass:"no-select-text"},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }